module.exports = __webpack_public_path__ + "static/media/refex.02ea607d.svg";